module.exports = __webpack_public_path__ + "static/media/Gotham-LightItalic.890c2b47.ttf";